import { render } from "./MenuItem.vue?vue&type=template&id=47ce7a8a"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=47ce7a8a&lang=scss"
script.render = render

export default script